export const layout = {
  main: 'main-area',
  footer: 'footer-area',
};
